module.exports = __webpack_public_path__ + "static/media/weezly_logo.759bb8ec.svg";